module.exports = __webpack_public_path__ + "static/media/icon_volume_off.80080054.svg";